import Vue from 'vue'

Vue.prototype.$isBuyer = false
Vue.prototype.$isSeller = true

require('../src/main')
